import React from "react";
import SubmitButton from "./submit-button";
import { useFormContext } from "react-hook-form";
import Button from "./button";
import { BackNextButtonsProps } from "./types";
import { observer } from "mobx-react-lite";


const getBlankAnalytics = (name: string) => {
  return {};
};

const BackNextButtons = observer((props: BackNextButtonsProps) => {
  const {
    backClick,
    showBack,
    showNext,
    saveOnBack = false,
    onSave = undefined,
    backButtonText = "Back",
    submitButtonText = "Next",
    getBackButtonAnalytics = getBlankAnalytics,
    getNextButtonAnalytics = getBlankAnalytics
  } = props;

  const { getValues } = useFormContext();

  const goBack = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (saveOnBack && onSave !== undefined) {
      onSave(getValues());
    }

    backClick(event);
  }

  const cssClasses = !showBack ? "btn-disabled" : "btn";

  const backButtonAnalytics = getBackButtonAnalytics(backButtonText);
  const nextButtonAnalytics = getNextButtonAnalytics(submitButtonText);

  return (
    <div className="button-toolbar">
      <Button
        colour="outline-dark"
        className={cssClasses}
        text={backButtonText}
        {...backButtonAnalytics}
        disabled={showBack === false}
        onClick={goBack} />

      <SubmitButton
        color="primary"
        text={submitButtonText}
        {...nextButtonAnalytics}
        disabled={showNext === false} />
    </div>
  )
});

export default BackNextButtons;
